<template>
    <div class="w-400 p-24 flex flex-col gap-16">

        <div class="space-y-8">
            <div class="text-body">
                {{ $t('site_editor.layout.font.display.title') }}
            </div>

            <div class="text-body-sm text-primary-80">
                {{ $t('site_editor.layout.font.display.description') }}
            </div>

            <select-dropdown
                :options="availableFonts"
                :value="form.display_font"
                @change="updateDisplayFont($event)"
                searchable
            >
                <template #list-item="{item}">
                    <font-preview :font="item.value"/>
                </template>
            </select-dropdown>
        </div>

        <div class="space-y-8">
            <div class="text-body">
                {{ $t('site_editor.layout.font.text.title') }}
            </div>

            <div class="text-body-sm text-primary-80">
                {{ $t('site_editor.layout.font.text.description') }}
            </div>

            <select-dropdown
                :options="availableFonts"
                :value="form.text_font"
                @change="updateTextFont($event)"
            >
                <template #list-item="{item}">
                    <font-preview :font="item.value"/>
                </template>
            </select-dropdown>
        </div>

    </div>
</template>

<script>
import SimpleDropdown from './SimpleDropdown.vue';
import FontPreview from './FontPreview.vue';
import SvgIcon from './SvgIcon.vue';
import WebFont from 'webfontloader';
import { fonts } from '../../../shared/helpers';
import Form from '../../etc/forms/Form';
import SelectDropdown from "../forms/SelectDropdown.vue";

export default {
    components: {
        SelectDropdown,
        'simple-dropdown': SimpleDropdown,
        'font-preview': FontPreview,
        'svg-icon': SvgIcon,
    },
    props: {
        form: {
            type: Form,
            required: true,
        }
    },
    computed : {
        availableFonts () {
            // We can merge in custom fonts here, when we implement that functionality.
            return [
                'Inter', 'System Serif', 'System Mono', 'Work Sans', 'Ubuntu', 'Titillium Web', 'Source Sans Pro', 'Rubik', 'Roboto Slab', 'Roboto Mono',
                'Roboto Condensed', 'Roboto', 'Raleway', 'PT Serif', 'Quicksand', 'PT Sans Narrow', 'PT Sans', 'Poppins', 'Playfair Display', 'Oswald',
                'Open Sans Condensed', 'Open Sans', 'Nunito Sans', 'Nunito', 'Noto Sans', 'Noto Serif', 'Nanum Gothic', 'Muli', 'Montserrat', 'Merriweather',
                'Lora', 'Libre Franklin', 'Libre Baskerville', 'Lato', 'Josefin Sans', 'Inconsolata', 'Fira Sans', 'Dosis', 'Crimson Text', 'Bitter',
                'Cabin', 'Arimo', 'Alegreya Sans'
            ].map(font => {
                return {
                    value: font,
                    label: font,
                }
            })
        }
    },
    methods: {
        updateDisplayFont (font) {
            this.loadFont(font, font => {
                this.form.display_font = font;
            });
        },
        updateTextFont (font) {

            this.loadFont(font, font => {
                this.form.text_font = font;
            });
        },
        loadFont (font, callback) {

            if (!fonts.isSystemFont(font)) {

                WebFont.load({
                    google: {
                        families: [font + ':400,700']
                    },
                    fontactive (e) {
                        callback(font);
                    }
                });
            } else {
                callback(font);
            }
        }
    }
}
</script>

<style scoped>

</style>
